import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { TitleScene } from './scenes/TitleScene';
import { WorldScene } from './scenes/WorldScene';
import { InteriorScene } from './scenes/InteriorScene';
import { ForestScene } from './scenes/ForestScene';
import { BeachScene } from './scenes/BeachScene';
import { TownScene } from './scenes/TownScene';
import { MineScene } from './scenes/MineScene';
import { UIScene } from './scenes/UIScene';
import { DebugScene } from './scenes/DebugScene';

export function createGame(): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game',
    backgroundColor: '#2d3b2f',
    pixelArt: true,
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: window.innerWidth,
      height: window.innerHeight,
    },
    // Touch-only target; movement is grid BFS, so no physics engine is used.
    scene: [BootScene, PreloadScene, TitleScene, WorldScene, InteriorScene, ForestScene, BeachScene, TownScene, MineScene, UIScene, DebugScene],
  });
}
